import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { datetimeFormat } from 'app/constants/date-time-format';
import { DataService, DateService, HelperService, HTTPService } from 'app/services';

@Component({
  selector: 'app-update-invoice-date-dialog',
  templateUrl: './update-invoice-date-dialog.component.html',
  styleUrls: ['./update-invoice-date-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
})
export class UpdateInvoiceDateDialogComponent implements OnInit, OnDestroy {
  isOpenAccordion: any = {
    finalize:false,
    invoice: false,
    created: false,
    authorize: false,
    payment: false,
  };

  isInvoiceBackDated: boolean = false;
  isFinalizsBackDated: boolean = false;
  isFinalizeBackdate: boolean = false;
  isShowFinalizeModal: boolean = false
  isCalendarFocusEnabled = false; 

  invoiceDateTime: any = {};
  finalizeDateTime: any = {};
  createdDateTime: any = {};
  authDateTime: any = {};

  data: any = {};
  paymentHistory: any = [];
  isProcessing: boolean = false;
  dateRange = new Date()

  constructor(
    private dialogConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    public dataService: DataService,
    public dateService: DateService,
    private httpService: HTTPService,
    public helperService: HelperService
  ) {}


  enableCalendarFocus(calendarRef: any): void {
    this.isCalendarFocusEnabled = !this.isCalendarFocusEnabled;
    if (this.isCalendarFocusEnabled) {
      calendarRef.showOverlay();
    } else {
      calendarRef.hideOverlay();
    }
    
  }

  ngOnDestroy(): void {}

  ngOnInit() {
    this.data = this.dialogConfig.data;
    this.invoiceDateTime = { ...this.dialogConfig.data.invoiceDateTime };
    this.finalizeDateTime = { ...this.dialogConfig.data.finalizeDateTime };
    this.createdDateTime = { ...this.dialogConfig.data.createdDateTime };
    this.authDateTime = { ...this.dialogConfig.data.authDateTime };
    this.isFinalizeBackdate = (this.data.isSupportUser && this.data.isRevenueRecognitionSettleEnabled) ? true : false
    this.dateRange = this.dateService.getCurrentDateTimeTz(new Date().getTime());
    console.log(this.data)
    if(this.isFinalizeBackdate){
      this.checkFinalizeBackDated()
      this.isShowFinalizeModal= false
    } else {
      this.isShowFinalizeModal= true
    }
    this.checkInvoiceBackDated();
    this.getPaymentHistory();
  }

  getPaymentHistory() {
    this.httpService.getPaymentHistoryByOrderId(this.data.orderId).then(
      (history: any[]) => {
        this.paymentHistory = history;
        this.paymentHistory.forEach((payment) => {
          const createdDate = new Date(payment.paymentDate);
          payment.paymentDateTime = { date: '', time: '' };
          payment.paymentDateTime.date = new Date(createdDate);
          payment.paymentDateTime.time = new Date(createdDate);
          payment.createdDate = createdDate;
        });
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  closePaymentModal() {
    this.ref.close(false);
  }

  checkFinalizeBackDated() {
    if (this.finalizeDateTime.date && this.finalizeDateTime.time) {
      const finalizedateTime = `${this.dateService.formatDate(this.finalizeDateTime.date, datetimeFormat.yyymmdd)} ${this.dateService.formatDate(this.finalizeDateTime.time, datetimeFormat.hhmm)}`;
      const invoiceDateTime = `${this.dateService.formatDate(this.data.invoiceDateTime.date, datetimeFormat.yyymmdd)} ${this.dateService.formatDate(
        this.data.invoiceDateTime.time,
        datetimeFormat.hhmm
      )}`;

      if (new Date(finalizedateTime).getTime() <= new Date(invoiceDateTime).getTime()) {
        this.isFinalizsBackDated = true;
        this.isShowFinalizeModal = true;
        this.invoiceDateTime.date = this.finalizeDateTime.date;
        this.invoiceDateTime.time = this.dateService.subtractPeriodFromDate(5, 'minutes', this.finalizeDateTime.time).toDate();
        this.authDateTime.date = this.finalizeDateTime.date;
        this.authDateTime.time = this.dateService.subtractPeriodFromDate(5, 'minutes', this.finalizeDateTime.time).toDate();
        this.checkInvoiceBackDated()
      } else {
        this.isFinalizsBackDated = false;
        this.isShowFinalizeModal = false;
        this.isInvoiceBackDated = false
      }
    }
  }

  checkInvoiceBackDated() {
    if (this.invoiceDateTime.date && this.invoiceDateTime.time) {
      const invoicedateTime = `${this.dateService.formatDate(this.invoiceDateTime.date, datetimeFormat.yyymmdd)} ${this.dateService.formatDate(this.invoiceDateTime.time, datetimeFormat.hhmm)}`;
      const createddateTime = `${this.dateService.formatDate(this.data.createdDateTime.date, datetimeFormat.yyymmdd)} ${this.dateService.formatDate(
        this.data.createdDateTime.time,
        datetimeFormat.hhmm
      )}`;

      if (new Date(invoicedateTime).getTime() < new Date(createddateTime).getTime()) {
        this.isInvoiceBackDated = true;
        this.createdDateTime.date = this.invoiceDateTime.date;
        this.createdDateTime.time = this.dateService.subtractPeriodFromDate(10, 'minutes', this.invoiceDateTime.time).toDate();
        this.authDateTime.date = this.invoiceDateTime.date;
        this.authDateTime.time = this.dateService.subtractPeriodFromDate(5, 'minutes', this.invoiceDateTime.time).toDate();
      } else {
        this.isInvoiceBackDated = false;
      }
    }
  }

  onSelectFinalizeeDateTime(type: string, data: any) {
    this.finalizeDateTime[type] = data;
    this.checkFinalizeBackDated();
  }

  onSelectInvoiceDateTime(type: string, data: any) {
    this.invoiceDateTime[type] = data;
    this.checkInvoiceBackDated();
  }

  handleDateCardAccordion(type) {
    this.isOpenAccordion[type] = !this.isOpenAccordion[type];
  }

  onSubmit() {
    if (!this.invoiceDateTime.time) {
      this.helperService.showToaster('error', `Please select valid time`);
      return;
    }
    const finalizeDate = `${this.dateService.formatDate(this.finalizeDateTime.date, datetimeFormat.yyymmdd)} ${this.dateService.formatDate(this.finalizeDateTime.time, datetimeFormat.hhmm)}`;
    const invoicedateTime = `${this.dateService.formatDate(this.invoiceDateTime.date, datetimeFormat.yyymmdd)} ${this.dateService.formatDate(this.invoiceDateTime.time, datetimeFormat.hhmm)}`;
    const createddateTime = `${this.dateService.formatDate(this.createdDateTime.date, datetimeFormat.yyymmdd)} ${this.dateService.formatDate(this.createdDateTime.time, datetimeFormat.hhmm)}`;
    const authdateTime = `${this.dateService.formatDate(this.authDateTime.date, datetimeFormat.yyymmdd)} ${this.dateService.formatDate(this.authDateTime.time, datetimeFormat.hhmm)}`;
    const paymentDates = [];

    if(this.isFinalizeBackdate) {
      if (new Date(finalizeDate).getTime() < new Date(invoicedateTime).getTime()) {
        this.helperService.showToaster('error', `The finalization generation date time must be greater than RO's inovice date`);
        return;
      }
    }
    if (this.isInvoiceBackDated) {
      if (new Date(invoicedateTime).getTime() < new Date(createddateTime).getTime()) {
        this.helperService.showToaster('error', `The Invoice generation date time must be greater than RO's creation date`);
        return;
      }
      if (new Date(invoicedateTime).getTime() < new Date(authdateTime).getTime()) {
        this.helperService.showToaster('error', `The authorization generation date time must be less than RO's invoice date`);
        return;
      }
      if (new Date(createddateTime).getTime() > new Date(authdateTime).getTime()) {
        this.helperService.showToaster('error', `The authorization generation date time must be greater than RO's creation date`);
        return;
      }
      this.paymentHistory.forEach((payment) => {
        const paymentdateTime = `${this.dateService.formatDate(payment.paymentDateTime.date, datetimeFormat.yyymmdd)} ${this.dateService.formatDate(
          payment.paymentDateTime.time,
          datetimeFormat.hhmm
        )}`;
        if (new Date(paymentdateTime).getTime() < new Date(invoicedateTime).getTime()) {
          this.helperService.showToaster('error', `The payment generation date time must be greater than RO's invoice date`);
          return;
        }
        paymentDates.push({ _id: payment._id, paymentDate: paymentdateTime });
      });
    }

    this.isProcessing = true;
    let payload = {};
    if (this.isInvoiceBackDated) {
      payload = {
        createdAt: createddateTime,
        approvedAt: authdateTime,
        invoiceDate: invoicedateTime,
        paymentDates,
      };
    } else {
      payload = {
        createdAt: createddateTime,
        invoiceDate: invoicedateTime,
      };
    }

    if(this.isFinalizeBackdate) {
      payload['finalizeDate'] = finalizeDate
    }
    console.log(payload)
    this.httpService.updateOrderDates(this.data.orderId, payload).then(
      (res) => {
        this.isProcessing = false;
        this.ref.close({ isSuccess: true, data: res });
      },
      (error) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', error);
      }
    );
  }
}
